const subscribers = new Set()

const handlePageShow = (event) => {
    if (!event.persisted) return

    subscribers.forEach((subscriber) => subscriber())
}

export const subscribeToBFCacheRestore = (subscriber) => {
    if (typeof window === 'undefined') return () => {}

    if (subscribers.size === 0) {
        window.addEventListener('pageshow', handlePageShow)
    }

    subscribers.add(subscriber)

    return () => {
        subscribers.delete(subscriber)

        if (subscribers.size === 0) {
            window.removeEventListener('pageshow', handlePageShow)
        }
    }
}
